import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyCr-pl-C8gRmszmtRx0LgWHyB8fYxqVGKc",
    authDomain: "soccerhow-e4025.firebaseapp.com",
    projectId: "soccerhow-e4025",
    storageBucket: "soccerhow-e4025.firebasestorage.app",
    messagingSenderId: "60291749870",
    appId: "1:60291749870:web:0ec8330d3344beda5320ff",
    measurementId: "G-63N09F2NNV"
};

initializeApp(firebaseConfig);

class WebPushManager {
    async getToken(){
        let flag = true;
        let msg = '';
        let token = '';

        try {
            const currentToken = await getToken(getMessaging(), { vapidKey: 'BAhRtt0HPr_fl9d9WcMAOG5GOu1roEMyCiZcepiQjDLF2dlvaI8lbT5MkEwAmw7jyWg3Js0QWcrVjnKGHt0zmVE' })
            if (currentToken) {
                console.log('token', currentToken);
                token = currentToken;
            } else {
                console.log('No registration token available. Request permission to generate one.');
                flag = false;
                msg = '토큰 없음';
            }
        }catch (e){
            flag = false;
            console.log('An error occurred while retrieving token. ', e);
            msg = '에러:' + e;
        }

        return [flag, token, msg]
    }

    async registServiceWorker(){
        try {
            const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
            console.log("Service Worker 등록 성공:", registration);
        } catch (error) {
            console.log("Service Worker 등록 실패:", error);
        }
    }

    async waitSeconds(sec){
        return new Promise((resolve, reject) => {
            reject;
            setTimeout(() => {
                resolve();
            }, sec * 1000)
        })
    }

    async requestPermission(){
        let permission;
        try{
            permission = await Notification.requestPermission();
        }catch(e){
            return [false, '', '에러'];
        }

        if (permission === 'granted') {
            await this.registServiceWorker();
            await this.waitSeconds(2);
            let [isSuccess, token, msg] = await this.getToken();
            if(isSuccess) return [isSuccess, token, msg];

            //재시도
            await this.waitSeconds(2);
            return await this.getToken();

        } else if (permission === 'denied') {
            console.log('푸시 권한 차단')
        }
        return [false, '', '권한 차단'];
    }
}

const webPushManager = new WebPushManager();

export default webPushManager;